/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type SerieLayer = typeof SerieLayer[keyof typeof SerieLayer];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SerieLayer = {
  Terms: 'Terms',
  OperationScheme: 'OperationScheme',
  ProductCostScheme: 'ProductCostScheme',
  Calculation: 'Calculation',
} as const;
